import { reports } from "../constant";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
export var REPORTTAB;
(function (REPORTTAB) {
    REPORTTAB["DASHBOARD"] = "DASHBOARD";
    REPORTTAB["HOLDING"] = "HOLDING";
    REPORTTAB["POSITION"] = "POSITION";
    REPORTTAB["ORDERBOOK"] = "ORDERBOOK";
    REPORTTAB["PNL"] = "PNL";
})(REPORTTAB || (REPORTTAB = {}));
export var SORT_FILTER_TYPE_TABS;
(function (SORT_FILTER_TYPE_TABS) {
    SORT_FILTER_TYPE_TABS["SORT"] = "SORT";
    SORT_FILTER_TYPE_TABS["ASSET"] = "ASSET";
    SORT_FILTER_TYPE_TABS["TYPE"] = "TYPE";
})(SORT_FILTER_TYPE_TABS || (SORT_FILTER_TYPE_TABS = {}));
export const omnesysTablist = [
    { title: "", eventKey: SORT_FILTER_TYPE_TABS.SORT },
];
export const FilterSortContent = [
    { title: "Assets", eventKey: SORT_FILTER_TYPE_TABS.ASSET },
    { title: "Type", eventKey: SORT_FILTER_TYPE_TABS.TYPE },
    { title: "Sort", eventKey: SORT_FILTER_TYPE_TABS.SORT },
];
export const ActionFilters = [
    { title: "Tradeable holdings", key: "tradable" },
    { title: "Pledged Scrips", key: "pledge" },
    { title: "Scrips with CUSA", key: "Cusa" },
    { title: "MTF Scrips", key: "mtf" },
    { title: "Scrips with News", key: "news" },
    { title: "Scrips with corp. action today", key: "corpaction" },
    { title: "Scrips with research recommendations", key: "recommendation" },
];
export var DownlodReportType;
(function (DownlodReportType) {
    DownlodReportType["DOWNLOADHOLDINGSREPORT"] = "holding";
    DownlodReportType["PNLREPORT"] = "profitandloss";
    DownlodReportType["PULLDPTRANSACTIONS"] = "PullDPTxn";
})(DownlodReportType || (DownlodReportType = {}));
export var EBtnDNAproperties;
(function (EBtnDNAproperties) {
    EBtnDNAproperties["BUY"] = "buy";
    EBtnDNAproperties["SELL"] = "sell";
    EBtnDNAproperties["CANCEL"] = "cancel";
    EBtnDNAproperties["APPLY"] = "apply";
    EBtnDNAproperties["BORDERED"] = "cancel";
})(EBtnDNAproperties || (EBtnDNAproperties = {}));
export const BtnDNAproperties = {
    [EBtnDNAproperties.BUY]: {
        btnTyp: "green-btn",
        value: "BUY",
        className: " buy-btn",
        onClick: () => { },
    },
    [EBtnDNAproperties.SELL]: {
        btnTyp: "red-btn",
        value: "SELL",
        className: "sell-btn",
        onClick: () => { },
    },
    [EBtnDNAproperties.CANCEL]: {
        btnTyp: "midnight-blue-border",
        className: "dm-fam bg-transparent",
        value: "Cancel",
    },
    [EBtnDNAproperties.APPLY]: {
        btnTyp: "midnight-blue",
        className: "dm-fam",
        value: "Apply",
    },
};
export const rowData = [
    {
        fieldNameL: "Avg Price",
        keyL: "averagePrice",
        fieldNameR: "LTP",
        keyR: "lastTradedPrice",
        keyR1: "changePercentage",
        streamR1: true,
    },
    {
        fieldNameL: "Invested",
        keyL: "investmentValue",
        fieldNameR: "Current",
        keyR: "currentValue",
    },
    {
        fieldNameL: "P&L",
        keyL: "pnl",
        streamL: true,
        keyL1: "pnlChangePercentage",
        streamL1: true,
        fieldNameR: "1D P&L",
        keyR: "dayChange",
        keyR1: "changePercentage",
        streamR: true,
    },
];
export const omnesysHoldingData = [
    {
        fieldNameL: "Current",
        keyL: "currentValue",
        keyL1: "",
        fieldNameR: "LTP",
        keyR: "lastTradedPrice",
        keyR1: "changePercentage",
        streamR1: true,
    },
];
export const reportConstants = {
    holding: "Holding",
    profitandloss: "Profit & Loss",
    PullDPTxn: "DP Transections",
};
export var EReportDownloadStatus;
(function (EReportDownloadStatus) {
    EReportDownloadStatus["LOADING"] = "LOADING";
    EReportDownloadStatus["SUCCESSFUL"] = "SUCCESSFUL";
    EReportDownloadStatus["FAILED"] = "FAILED";
})(EReportDownloadStatus || (EReportDownloadStatus = {}));
export var EReportRoutes;
(function (EReportRoutes) {
    EReportRoutes["dashboard"] = "dashboard";
    EReportRoutes["holding"] = "holding";
    EReportRoutes["positions"] = "positions";
    EReportRoutes["orderbook"] = "orderbook";
    EReportRoutes["profitandloss"] = "profitandloss";
    EReportRoutes["downloadReport"] = "download-report";
    EReportRoutes["tax"] = "tax";
})(EReportRoutes || (EReportRoutes = {}));
// paths
export const reportsRoutePaths = {
    [EReportRoutes.dashboard]: reports + EReportRoutes.dashboard,
    [EReportRoutes.holding]: reports + EReportRoutes.holding,
    [EReportRoutes.positions]: reports + EReportRoutes.positions,
    [EReportRoutes.orderbook]: reports + EReportRoutes.orderbook,
    [EReportRoutes.profitandloss]: reports + EReportRoutes.profitandloss,
    [EReportRoutes.downloadReport]: reports + EReportRoutes.downloadReport,
    [EReportRoutes.tax]: reports + EReportRoutes.tax,
};
export const reportsRouteLinks = {
    [EReportRoutes.dashboard]: {
        title: "Dashboard",
        navigateTo: reportsRoutePaths[EReportRoutes.dashboard],
    },
    [EReportRoutes.holding]: {
        title: "Holdings",
        navigateTo: reportsRoutePaths[EReportRoutes.holding],
    },
    [EReportRoutes.positions]: {
        title: "Positions",
        navigateTo: reportsRoutePaths[EReportRoutes.positions],
    },
    [EReportRoutes.orderbook]: {
        title: "Orderbook",
        navigateTo: reportsRoutePaths[EReportRoutes.orderbook],
    },
    [EReportRoutes.profitandloss]: {
        title: "Profit & Loss",
        navigateTo: reportsRoutePaths[EReportRoutes.profitandloss],
    },
    [EReportRoutes.tax]: {
        title: "Tax",
        navigateTo: reportsRoutePaths[EReportRoutes.tax],
    },
};
export var TAX_DOWNLOAD_STATE;
(function (TAX_DOWNLOAD_STATE) {
    TAX_DOWNLOAD_STATE["SELECTION"] = "SELECTION";
    TAX_DOWNLOAD_STATE["DOWNLOAD_EMAIL"] = "DOWNLOAD_EMAIL";
})(TAX_DOWNLOAD_STATE || (TAX_DOWNLOAD_STATE = {}));
export const iconsArray = {
    "edel-icon-report-excla": { className: "edel-icon-report-excla", paths: 3 },
    "edel-icon-no-holdings": { className: "edel-icon-no-holdings", paths: 6 },
    "edel-icon-filter-cross-coloured": {
        className: "edel-icon-filter-cross-coloured",
        paths: 2,
    },
};
export const holdingDataMessages = {
    "edel-icon-report-excla": {
        msgUP: "No results found !",
        msgDown: "Try searching for something else",
    },
    "edel-icon-no-holdings": {
        msgUP: "You don’t have any holdings",
        msgDown: "Try searching for something else",
    },
    "edel-icon-filter-cross-coloured": {
        msgUP: "No holdings matching filters",
        msgDown: "Try removing some filters to view holdings",
    },
};
export const getRadioBtns = (reportName) => {
    if (reportName === ReportName.HOLDINGS)
        return [
            { title: "PDF (Detailed)", value: ReportType.PDF_DETAIL },
            { title: "PDF (Summary)", value: ReportType.PDF_SUMMARY },
            { title: "Excel", value: ReportType.EXCEL },
        ];
    return [
        { title: "PDF", value: ReportType.PDF },
        { title: "Excel", value: ReportType.EXCEL },
    ];
};
